import { ComponentProps } from "react";

import { PanesWithControls } from "dev";
import { View } from "react-native";
import { IconButton } from "react-native-paper";
import { useTailwind } from "tailwind-rn";
import { Header, TabBar } from "ui";

const { log } = console;

export default function HeaderPage() {
  return (
    <PanesWithControls showBorder>
      <Header title="Title only" />
      <Header title="Back button" onBackPress={log} />
      <Header title="Pad left" padLeft />
      <Header title="Close button" onClosePress={log} />
      <Header
        title="Custom right btn"
        rightAction={<IconButton icon="delete" />}
      />
      <Header title="Both buttons" onBackPress={log} onClosePress={log} />

      <HeaderWithTabBar title="With children" />
      <HeaderWithTabBar title="Children and back" onBackPress={log} />
      <HeaderWithTabBar title="Children and close" onClosePress={log} />
      <HeaderWithTabBar title="Children and padLeft" padLeft />
      <HeaderWithTabBar
        title="Children aligned to edges and back button"
        onBackPress={log}
        childrenHorizontalAlignMode="edges"
      />
      <HeaderWithTabBar
        title="Children aligned to edges and padLeft"
        padLeft
        childrenHorizontalAlignMode="edges"
      />
      <HeaderWithTabBar
        title="Children aligned to edges and both buttons"
        onBackPress={log}
        onClosePress={log}
        childrenHorizontalAlignMode="edges"
      />
    </PanesWithControls>
  );
}

// same props as header, just a wrapper with a tab bar to show children
function HeaderWithTabBar(props: ComponentProps<typeof Header>) {
  const tailwind = useTailwind();
  const values = ["tabOne", "tabTwo", "tabThree"];
  return (
    <Header {...props}>
      <TabBar values={values} selectedValue={values[0]} selectValue={log} />
      {/* full width view with bg used to show component bounds */}
      <View style={tailwind("h-1 w-full bg-red-100")} />
    </Header>
  );
}
